var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"web-component-bg\"> <div class=\"field-wrapper terms-cb\"> <label>&nbsp;</label> <input type=\"checkbox\" id=\"accept_terms\" ng-model=\"$ctrl.data.AcceptTerms\"/> <label for=\"accept_terms\"> <span class=\"glyphicon glyphicon-ok\"></span>\n<a href=\"javascript:void(0)\" ng-click=\"$ctrl.openLink != null ? $ctrl.goToLink() : $ctrl.winresReservationContext.getReservationTermsOpener()()\"> {{ 'reservation_customer.accept_terms2' | i18next }} </a> </label> </div> </div> </web-component>";
var id1="termsAccept.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/termsAccept/termsAccept.html
// module id = 279
// module chunks = 2